import styled, { css } from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`
export const LeftMenu = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 19rem;
    min-width: 18rem;
    & > div {
        margin-top: 1rem;
    }
`
export const SearchTitle = styled.div`
    color: ${ThemeColors.getGrayColor(0.7)};
    font-size: 1.1rem;
`

interface IRightBlockProps {
    isLeftBlock: boolean
}

export const RightBlock = styled.div<IRightBlockProps>`
    box-sizing: border-box;
    width: 100%;
    max-width: 54rem;
`
